import React, { useEffect, useState ,useRef} from "react";
import {
  Table,
  Select,
  Input,
  InputNumber,
  Button,
  Modal,
  Form,
  Row,
  Col,
  AutoComplete,
  Drawer,
  Empty
} from "antd";
import { Html5QrcodeScanner } from "html5-qrcode";



import { DatePicker } from "antd";
import { Dropdown, Menu } from "antd";
import { DownOutlined, InboxOutlined, PlusOutlined, ScanOutlined } from "@ant-design/icons";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { Tag, Tooltip } from "antd";
import { WarningOutlined, StopOutlined } from "@ant-design/icons";

 

import { getDrinks, createDrink,updateDrink } from "../../api/drinkApi";
import { deleteDrink} from "../../api/drinkApi";
import { deleteStock } from "../../api/stockApi";
import { getSuppliers } from "../../api/supplierApi";
import { addStock as addStockAPI, createNewStock,getStockByDrink ,updateStock } from "../../api/stockApi";
import { canViewModule, canCreateModule, canDeleteModule, canUpdateModule } from "../utils/permissionUtils";
import { notify } from "../components/Customs/NotifyProvider";
import "./Inventory.css";

const MODULE_KEY = "inventory";


function Inventory() {
const hasViewAccess = canViewModule(MODULE_KEY);

 


  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [stockSort, setStockSort] = useState("");

  // STOCK MODAL
  const [stockOpen, setStockOpen] = useState(false);
  const [stockForm] = Form.useForm();
  const [stockLogsMap, setStockLogsMap] = useState({});

  // ADD DRINK DRAWER
  const [drinkOpen, setDrinkOpen] = useState(false);
  const [drinkForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  //Editing drink
  const [editingDrinkId, setEditingDrinkId] = useState(null);
  //Editing stock id
  const [editingStockId, setEditingStockId] = useState(null);
   //NEW STOCK BUTTON
  const [newStockOpen, setNewStockOpen] = useState(false);
  const [newStockForm] = Form.useForm();
  const [suppliers, setSuppliers] = useState([]);
  const type = Form.useWatch("type", stockForm);
  const newType = Form.useWatch("type", newStockForm || "");


  ///scanner input
  const bottleCode = Form.useWatch("scan_bottle_code", newStockForm);
  const boxCode = Form.useWatch("scan_box_code", newStockForm);
  //Dte picker
  const [dateRange, setDateRange] = useState([]);

  //scanner icon 
  const [scanModalOpen, setScanModalOpen] = useState(false);
  const [scanField, setScanField] = useState("");


  const inputRef = useRef(null);

useEffect(() => {
  if (scanModalOpen) {
    setTimeout(() => {
      inputRef.current?.focus();
    }, 300);
  }
}, [scanModalOpen]);

  
  
   const { RangePicker } = DatePicker;

   

 const getFinalTypeFromLogs = (logs = []) => {
  const types = [...new Set(logs.map((log) => log.type).filter(Boolean))];

  if (types.includes("Box") && types.includes("Bottle")) {
    return "Box / Bottle";
  }

  if (types.includes("Box")) {
    return "Box";
  }

  if (types.includes("Bottle")) {
    return "Bottle";
  }

  return "";
 };

 const isDateInSelectedRange = (value) => {
  if (!dateRange?.length || dateRange.length !== 2 || !value) {
    return true;
  }

  const currentDate = new Date(value);
  const startDate = new Date(dateRange[0].format("YYYY-MM-DD"));
  const endDate = new Date(dateRange[1].format("YYYY-MM-DD"));

  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(23, 59, 59, 999);

  return currentDate >= startDate && currentDate <= endDate;
 };

 const setNewStockDrinkFields = (matchedDrink) => {
  if (matchedDrink) {
    newStockForm.setFieldsValue({
    
      name: matchedDrink?.name,
      drink_id: matchedDrink.id,
      category_name: matchedDrink.category_name,
      category_id: matchedDrink.category_id,
      margin_price: matchedDrink.margin_price,
      sell_price: matchedDrink.sell_price,
      type: matchedDrink.type,
      units_per_box: matchedDrink.units_per_box,
      bottle_volume: matchedDrink.qty,
      price_box: matchedDrink.price_box,
      price_per_bottle: matchedDrink.sell_price,
      box_qty: matchedDrink.box_qty,
      bottle_qty: matchedDrink.bottle_qty,
    });

    return;
  }

  newStockForm.setFieldsValue({
    drink_id: null,
   
    category_name: "",
    category_id: null,
    margin_price: "",
    sell_price: "",
    units_per_box: undefined,
    bottle_volume: undefined,
    price_box: undefined,
    price_per_bottle: undefined,
    box_qty: undefined,
    bottle_qty: undefined,
  });
 };

 const setStockDrinkFields = (matchedDrink) => {

  if (!matchedDrink) {
    return;
  }

  stockForm.setFieldsValue({
    drink_id: matchedDrink.id,
    bottle_volume: matchedDrink.qty,
    price_per_bottle: matchedDrink.sell_price,
  });
 };

 const drinkOptions = data.map((drink) => ({
  value: drink.name,
  label: drink.name,
  key: drink.id,
 }));

 //scan icon function

  useEffect(() => {
  let scanner;

  if (scanModalOpen) {
    scanner = new Html5QrcodeScanner("reader", {
      fps: 10,
      qrbox: { width: 250, height: 120 },
    });

    scanner.render(handleScanSuccess, handleScanError);
  }

  return () => {
    if (scanner) {
      scanner.clear().catch(() => {});
    }
  };
}, [scanModalOpen]);

 
 const openScanner = (fieldName) => {
  setScanField(fieldName);
  setScanModalOpen(true);
};

const handleFakeScan = () => {
  const fakeCode = "SCN" + Date.now();

  newStockForm.setFieldsValue({
    [scanField]: fakeCode,
  });

  setScanModalOpen(false);
};

const handleScanSuccess = async (decodedText) => {
  if (!decodedText || !scanField) return;

  const code = String(decodedText).trim();

  // update form immediately
  newStockForm.setFieldValue(scanField, code);
  stockForm.setFieldValue(scanField, code);

  console.log("SCANNED:", scanField, code);

  // close scanner
  setScanModalOpen(false);

 
};

const handleScanError = () => {
  // Ignore frame-by-frame scan decode noise.
};




 const fetchData = async () => {
  try {
    setLoading(true);

    const res = await getDrinks();

    const updated = res.data.map((item) => ({
      ...item,
      in_stock: item.in_stock ?? 0,
      total_stock: item.total_stock ?? 0,
    }));

    const stockLogsEntries = await Promise.all(
      updated.map(async (item) => {
        try {
          const logsRes = await getStockByDrink(item.id);
          return [item.id, logsRes.data || []];
        } catch (error) {
          console.error(`STOCK LOG FETCH ERROR FOR DRINK ${item.id}:`, error);
          return [item.id, []];
        }
      })
    );

    const nextStockLogsMap = Object.fromEntries(stockLogsEntries);

    setStockLogsMap(nextStockLogsMap);
    setData(
      updated.map((item) => ({
        ...item,
        type: getFinalTypeFromLogs(nextStockLogsMap[item.id] || []),
      }))
    );
  } catch (err) {
    console.error("FETCH DRINKS ERROR:", err);
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    if (!hasViewAccess) return;
    fetchData();
     fetchSuppliers();
  }, [hasViewAccess]);


//permission
  if (!hasViewAccess) {
    return (
      <div className="page-shell user-master-page">
        <div className="page-empty">
          <Empty description="No permission to view inventory" />
        </div>
      </div>
    );
  } 



   ///NEW DRAWER
  
const handleCreateNewStock = async () => {
  if (!canCreateModule(MODULE_KEY)) {
    notify.error("Permission Denied", "No permission to create stock");
    return;
  }

  try {
    // wait one tick so scanned form values fully update
    await new Promise((resolve) => setTimeout(resolve, 150));

    // get latest form values
    const values = await newStockForm.validateFields();

    console.log("LATEST FORM VALUES:", values);

    let drinkId = values.drink_id;

    // create drink if not exists
    if (!drinkId && values.name) {
      const res = await createDrink({
        name: values.name,
        category_id: values.category_id || null,
        sell_price: Number(values.sell_price || 0),
        margin_price: Number(values.margin_price || 0),
      });

      drinkId = res.data.drink_id ?? res.data.id ?? null;
    }

    if (!drinkId) {
      throw new Error("Drink selection or name required");
    }

    const payload = {
      drink_id: Number(drinkId),

      // scanner values force string
      scan_bottle_code: values.scan_bottle_code
        ? String(values.scan_bottle_code).trim()
        : null,

      scan_box_code: values.scan_box_code
        ? String(values.scan_box_code).trim()
        : null,

      name: values.name || "",
      category_id: values.category_id || null,
      supplier: values.supplier || null,

      type: values.type || "Box",

      sell_price: Number(values.sell_price || 0),
      margin_price: Number(values.margin_price || 0),

      units_per_box: Number(values.units_per_box || 0),
      bottle_volume: Number(values.bottle_volume || 0),

      price_box: Number(values.price_box || 0),
      price_per_bottle: Number(values.price_per_bottle || 0),

      box_qty: Number(values.box_qty || 0),
      bottle_qty: Number(values.bottle_qty || 0),

      in_stock: Number(values.in_stock || 0),
      paid_amount: Number(values.paid_amount || 0),

      updated_by: "admin",
    };

    console.log("FINAL PAYLOAD:", payload);

    await createNewStock(payload);

    await loadStockLogs(drinkId);
    await fetchData();

    setNewStockOpen(false);
    newStockForm.resetFields();

    notify.success("Stock created successfully");
  } catch (err) {
    console.error("NEW STOCK ERROR:", err);
    notify.error(
      err?.response?.data?.message || err.message || "Failed to create stock"
    );
  }
};

//fetching supplier id
const fetchSuppliers = async () => {
  try {
    const res = await getSuppliers();
    setSuppliers(res.data);
  } catch (err) {
    console.error("SUPPLIER FETCH ERROR:", err);
  }
};
//to clear field of new stock drawer

const handleCloseNewStock = () => {
  setNewStockOpen(false);
  newStockForm.resetFields();   //  important fix
};

const safeNumber = (value) => Number(value) || 0;

const getStockSummary = (logs = []) => {
  const totalPaid = logs.reduce(
    (sum, log) => sum + safeNumber(log.paid_amount),
    0
  );

  const totalBox = logs.reduce(
    (sum, log) => sum + safeNumber(log.box_qty),
    0
  );

  const totalBottle = logs.reduce(
    (sum, log) =>
      sum +
      safeNumber(log.box_qty) * safeNumber(log.units_per_box) +
      safeNumber(log.bottle_qty),
    0
  );

  const totalVolumeLTR = logs.reduce(
    (sum, log) =>
      sum +
      (safeNumber(log.box_qty) *
        safeNumber(log.units_per_box) *
        safeNumber(log.bottle_volume)) /
        1000,
    0
  );

  return {
    totalPaid,
    totalBox,
    totalBottle,
    totalVolumeLTR,
  };
};

const csvEscape = (value) => {
  const text = value == null ? "" : String(value);
  return `"${text.replace(/"/g, '""')}"`;
};

 const loadStockLogs = async (drinkId) => {
  const res = await getStockByDrink(drinkId);

  const logs = Array.isArray(res) ? res : res.data || [];

  setStockLogsMap((prev) => ({
    ...prev,
    [Number(drinkId)]: logs,
  }));

  const finalType = getFinalTypeFromLogs(logs);

  setData((prev) =>
    prev.map((item) =>
      item.id === drinkId
        ? { ...item, type: finalType }
        : item
    )
  );
};

//export csv 
const exportToCSV = () => {
  const mainHeaders = [
    "Name",
    "Category",
    "Qty",
    "Unit",
    "Sell Price",
    "Original Price",
    "Type",
    "In Stock",
    "Status",
  ];

  const subHeaders = [
    "S.No",
    "Type",
    "Supplier",
    "Units/Box",
    "Bottle ML",
    "Price/Box",
    "Price/Bottle",
    "Box Qty",
    "Bottle Qty",
    "Paid Amount",
    "Added Stock",
    "Date",
  ];

  const rows = [];

  filteredData.forEach((item, index) => {
    const logs = stockLogsMap[Number(item.id)] || [];
    const summary = getStockSummary(logs);

    rows.push([`Drink ${index + 1}`]);
    rows.push(mainHeaders);
    rows.push([
      item.name,
      item.category_name,
      item.qty,
      item.unit,
      item.sell_price,
      item.margin_price,
      item.type,
      item.in_stock,
      item.status || "Active",
    ]);
    rows.push([]);
    rows.push(["Summary", "Value"]);
    rows.push(["Total Box", summary.totalBox]);
    rows.push(["Total Bottle", summary.totalBottle]);
    rows.push(["Total Volume (L)", summary.totalVolumeLTR.toFixed(2)]);
    rows.push(["Total Paid", summary.totalPaid]);
    rows.push([]);
    rows.push(subHeaders);

    if (logs.length) {
      logs.forEach((log, logIndex) => {
        rows.push([
          logIndex + 1,
          log.type,
          log.supplier,
          log.units_per_box,
          log.bottle_volume,
          log.price_box,
          log.price_per_bottle,
          log.box_qty,
          log.bottle_qty,
          log.paid_amount,
          log.in_stock,
          log.added_on ? new Date(log.added_on).toLocaleString() : "-",
        ]);
      });
    } else {
      rows.push(["No stock logs found"]);
    }

    rows.push([]);
  });

  const csvContent =
    "data:text/csv;charset=utf-8," +
    rows.map((row) => row.map(csvEscape).join(",")).join("\n");

  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute(
    "download",
    dateRange?.length === 2
      ? `inventory_report_${dateRange[0].format("YYYY-MM-DD")}_to_${dateRange[1].format("YYYY-MM-DD")}.csv`
      : "inventory_report_all.csv"
  );
  document.body.appendChild(link);
  link.click();
};

//export pdf
const exportToPDF = () => {
  const doc = new jsPDF();

  doc.text("Inventory Report", 14, 10);
  let currentY = 20;

  const mainColumns = [
    "Name",
    "Category",
    "Qty",
    "Unit",
    "Sell Price",
    "Original Price",
    "Type",
    "In Stock",
    "Status",
  ];

  const subColumns = [
    "S.No",
    "Type",
    "Supplier",
    "Units/Box",
    "Bottle ML",
    "Price/Box",
    "Price/Bottle",
    "Box Qty",
    "Bottle Qty",
    "Paid Amount",
    "Added Stock",
    "Date",
  ];

  filteredData.forEach((item, index) => {
    const logs = stockLogsMap[Number(item.id)] || [];
    const summary = getStockSummary(logs);

    doc.setFontSize(12);
    doc.text(`Drink ${index + 1}: ${item.name}`, 14, currentY);
    currentY += 4;

    autoTable(doc, {
      head: [mainColumns],
      body: [[
        item.name,
        item.category_name,
        item.qty,
        item.unit,
        item.sell_price,
        item.margin_price,
        item.type,
        item.in_stock,
        item.status || "Active",
      ]],
      startY: currentY,
    });

    currentY = (doc.lastAutoTable?.finalY || currentY) + 6;

    autoTable(doc, {
      head: [["Summary", "Value"]],
      body: [
        ["Total Box", summary.totalBox],
        ["Total Bottle", summary.totalBottle],
        ["Total Volume (L)", summary.totalVolumeLTR.toFixed(2)],
        ["Total Paid", summary.totalPaid],
      ],
      startY: currentY,
      tableWidth: 90,
    });

    currentY = (doc.lastAutoTable?.finalY || currentY) + 6;

    autoTable(doc, {
      head: [subColumns],
      body: logs.length
        ? logs.map((log, logIndex) => [
            logIndex + 1,
            log.type,
            log.supplier,
            log.units_per_box,
            log.bottle_volume,
            log.price_box,
            log.price_per_bottle,
            log.box_qty,
            log.bottle_qty,
            log.paid_amount,
            log.in_stock,
            log.added_on ? new Date(log.added_on).toLocaleString() : "-",
          ])
        : [["", "No stock logs found", "", "", "", "", "", "", "", "", "", ""]],
      startY: currentY,
    });

    currentY = (doc.lastAutoTable?.finalY || currentY) + 10;
  });

  doc.save(
    dateRange?.length === 2
      ? `inventory_report_${dateRange[0].format("YYYY-MM-DD")}_to_${dateRange[1].format("YYYY-MM-DD")}.pdf`
      : "inventory_report_all.pdf"
  );
};


///export
const exportMenu = {
  items: [
    {
      key: "csv",
      label: "Export CSV",
      onClick: exportToCSV,
    },
    {
      key: "pdf",
      label: "Export PDF",
      onClick: exportToPDF,
    },
  ],
};





const closeDrinkModal = () => {
  setDrinkOpen(false);
  setEditingDrinkId(null);
  drinkForm.resetFields();
};

// edit button for stock
const handleEditStock = async (log) => {
  if (!canUpdateModule(MODULE_KEY)) {
    notify.error("Permission Denied", "No permission to update stock");
    return;
  }

  setEditingStockId(log.id);

  stockForm.setFieldsValue({
    drink_id: Number(log.drink_id),
    supplier: log.supplier,
    scan_bottle_code: log.scan_bottle_code || "",
    scan_box_code: log.scan_box_code || "",
    type: log.type || "Box",
    units_per_box: Number(log.units_per_box) || 0,
    bottle_volume: Number(log.bottle_volume) || 0,
    price_box: Number(log.price_box) || 0,
    box_qty: Number(log.box_qty) || 0,
    price_per_bottle: Number(log.price_per_bottle) || 0,
    bottle_qty: Number(log.bottle_qty) || 0,
    in_stock: Number(log.in_stock) || 0,
    paid_amount: Number(log.paid_amount) || 0,
  });

  setStockOpen(true);
};

   const handleEdit = (record) => {
  if (!canUpdateModule(MODULE_KEY)) {
    notify.error("Permission Denied", "No permission to update drink");
    return;
  }
  setEditingDrinkId(record.id);   // IMPORTANT 

  drinkForm.setFieldsValue({
    name: record.name,
    qty: record.qty,
    unit: record.unit,
    sell_price: record.sell_price,
    margin_price: record.margin_price,
  });

  setDrinkOpen(true);
};
  
// summary box
const boxStyle = {
  flex: 1,
  padding: 10,
  borderRadius: 8,
  background: "#f5f5f5",
  textAlign: "center",
};

//Delete drink button main table
const handleDelete = async (id) => {
  if (!canDeleteModule(MODULE_KEY)) {
    notify.error("Permission Denied", "No permission to delete drink");
    return;
  }

  try {
    await deleteDrink(id);
    await fetchData();
    notify.success("Drink deleted successfully");
  } catch (err) {
    notify.error(err?.response?.data?.message || "Failed to delete drink");
    console.error("DELETE DRINK ERROR:", err);
  }
};



//Delete Button for stock
const handleDeleteStock = async (stockId, drinkId) => {
  if (!canDeleteModule(MODULE_KEY)) {
    notify.error("Permission Denied", "No permission to delete stock");
    return;
  }

  try {
    await deleteStock(stockId);

    const res = await getStockByDrink(drinkId);

    setStockLogsMap((prev) => ({
      ...prev,
      [drinkId]: res.data,
    }));

    await fetchData();
    notify.success("Stock deleted successfully");
  } catch (err) {
    notify.error(err?.response?.data?.message || "Failed to delete stock");
    console.error("DELETE STOCK ERROR:", err);
  }
};

  // ================= UPDATE TABLE =================
  const handleChange = (value, record, field) => {
    const updated = data.map((item) =>
      item.id === record.id ? { ...item, [field]: value } : item
    );
    setData(updated);
  };

  // ================= ADD STOCK =================
  
const handleAddStock = async (values) => {
  if (editingStockId) {
    if (!canUpdateModule(MODULE_KEY)) {
      notify.error("Permission Denied", "No permission to update stock");
      return;
    }
  } else if (!canCreateModule(MODULE_KEY)) {
    notify.error("Permission Denied", "No permission to create stock");
    return;
  }

  try {
    const drinkId = Number(values.drink_id);

    if (!drinkId || isNaN(drinkId)) {
      console.error("Invalid Drink ID:", values.drink_id);
      return;
    }

    const payload = {
      ...values,
      drink_id: Number(values.drink_id) || 0,
      scan_bottle_code: values.scan_bottle_code || null,
      scan_box_code: values.scan_box_code || null,
      units_per_box: Number(values.units_per_box) || 0,
      bottle_volume: Number(values.bottle_volume) || 0,
      price_box: Number(values.price_box) || 0,
      price_per_bottle: Number(values.price_per_bottle) || 0,
      box_qty: Number(values.box_qty) || 0,
      bottle_qty: Number(values.bottle_qty) || 0,
      in_stock: Number(values.in_stock) || 0,
      paid_amount: Number(values.paid_amount) || 0,
      updated_by: "admin",
    };

    console.log("🔥 FINAL PAYLOAD:", payload);

    if (editingStockId) {
      await updateStock(editingStockId, payload);
      setEditingStockId(null);
      notify.success("Stock updated successfully");
    } else {
      await addStockAPI(payload);
      notify.success("Stock created successfully");
    }

    setStockOpen(false);
    stockForm.resetFields();

    await loadStockLogs(drinkId);
    await fetchData();

  } catch (err) {
    notify.error(err?.response?.data?.message || "Failed to save stock");
    console.error("STOCK SAVE ERROR:", err);
  }
};

//Edit drink correcting

const handleCreateDrink = async (values) => {
  if (editingDrinkId) {
    if (!canUpdateModule(MODULE_KEY)) {
      notify.error("Permission Denied", "No permission to update drink");
      return;
    }
  } else if (!canCreateModule(MODULE_KEY)) {
    notify.error("Permission Denied", "No permission to create drink");
    return;
  }

  try {
    //  UPDATE MODE
    if (editingDrinkId) {
      await updateDrink(editingDrinkId, values);
      setEditingDrinkId(null);
      notify.success("Drink updated successfully");
    }
    //  CREATE MODE
    else {
      await createDrink({
        ...values,
        status: "Active",
      });
      notify.success("Drink created successfully");
    }

    await fetchData();

    setDrinkOpen(false);
    drinkForm.resetFields();
  } catch (err) {
    notify.error(err?.response?.data?.message || "Failed to save drink");
    console.error("DRINK SAVE ERROR:", err);
  }
};

// ================= FILTERED DATA =================
const filteredData = data
  .filter((item) => {
    const s = search.toLowerCase();

    const matchSearch =
      item.name?.toLowerCase().includes(s) ||
      item.category_name?.toLowerCase().includes(s);

    const matchType = typeFilter ? item.type === typeFilter : true;

     //  DATE FILTER (stock logs based)
    let matchDate = true;

    if (dateRange?.length === 2) {
      const logs = stockLogsMap[Number(item.id)] || [];
      matchDate = logs.some((log) => isDateInSelectedRange(log.added_on));
    }

    return matchSearch && matchType && matchDate;
  })

   
  .sort((a, b) => {
    if (stockSort === "high") return b.in_stock - a.in_stock;
    if (stockSort === "low") return a.in_stock - b.in_stock;
    return 0;
  });

  // ================= TABLE =================
  const columns = [
    {
      title: "S.No",
      render: (_, __, index) => index + 1,
      width: 70,
    },
   
    { title: "Drinks Name", dataIndex: "name" },
    { title: "Category", render: (_, r) => r.category_name },
    { title: "Volume", dataIndex: "qty" },
    { title: "Unit", dataIndex: "unit" },
    { title: "Sell Price", dataIndex: "sell_price" },
    { title: "Original Price", dataIndex: "margin_price" },

        {
        title: "Status",
        dataIndex: "status",
        render: (status, record) => {
          const stock = record.in_stock || 0;

          const isInactive = status === "Inactive" || stock === 0;

          return (
            <Tag color={isInactive ? "red" : "green"}>
              {isInactive ? "Inactive" : "Active"}
            </Tag>
          );
        },
      },

      {
        title: "Stock Level",
        render: (_, record) => {
          const logs = stockLogsMap[Number(record.id)] || [];
          const summary = getStockSummary(logs);

          const box = summary.totalBox || 0;
          const bottle = summary.totalBottle || 0;

          const stock = box + bottle;

          if (stock === 0) {
            return <Tag color="red">Out of Stock</Tag>;
          }

          if (stock <= 10) {
            return <Tag color="orange">Low Stock</Tag>;
          }

          return <Tag color="green">In Stock</Tag>;
        }
      },

        {
        title: "Stock Details",
        align: "center",
        children: [

          {
            title: "Box",
            align: "center",
            render: (_, record) => {
              const logs = stockLogsMap[Number(record.id)] || [];
              const summary = getStockSummary(logs);
              return summary.totalBox;
            },
          },

          {
            title: "Bottle",
            align: "center",
            render: (_, record) => {
              const logs = stockLogsMap[Number(record.id)] || [];
              const summary = getStockSummary(logs);
              return summary.totalBottle;
            },
          },
        ],
      },
    

    {
  title: "Action",
  render: (_, record) => (
    <div style={{ display: "flex", gap: 8 }}>
      
     

      {/* EDIT */}
      <Button
        type="link"
        style={{ color: "#1677ff", padding:0}}
        disabled={!canUpdateModule(MODULE_KEY)}
        onClick={() => handleEdit(record)}
      >
        Edit
      </Button>

      {/* DELETE */}
      <Button
        type="link"
        danger
        style={{padding:0}}
        disabled={!canDeleteModule(MODULE_KEY)}
        onClick={() => handleDelete(record.id)}
      >
        Delete
      </Button>
    </div>
  ),
}
  ];

  return (
    <div className="page-shell user-master-page">
      <div className="user-page-header">
        <div className="user-page-header-left">
          <div className="user-page-icon">
            <InboxOutlined />
          </div>

          <div>
            <h2 className="user-page-title">Inventory Management</h2>
            <p className="user-page-subtitle">
              Track stock, manage drinks, and monitor inventory from one place.
            </p>
          </div>
        </div>

        <div className="user-page-header-actions">
            <Button
              type="primary"
              className="primary-btn"
              icon={<PlusOutlined />}
              onClick={() => {
                if (!canCreateModule(MODULE_KEY)) {
                  notify.error("Permission Denied", "No permission to create drink");
                  return;
                }

                setEditingDrinkId(null);
                drinkForm.resetFields();
                setDrinkOpen(true);
              }}
              disabled={!canCreateModule(MODULE_KEY)}
            >
              Add Drinks
            </Button>

            <Button
              type="primary"
              className="primary-btn"
              disabled={!canCreateModule(MODULE_KEY)}
              onClick={() => {
                if(!canCreateModule(MODULE_KEY)){
                  notify.error("No permission to create stock");
                  return;
                }
                setNewStockOpen(true);
                newStockForm.setFieldsValue({ type: "Box" });

              }}
            >
              New Stock
            </Button>

            <Dropdown menu={exportMenu} trigger={["click"]}>
              <Button>Export <DownOutlined /></Button>
            </Dropdown>
        </div>
      </div>

      <div className="page-card filter-card">
        <div className="table-card-header">
          <div>
            <h3>Inventory Filters</h3>
            <p>Search, sort, and filter your stock records.</p>
          </div>
        </div>

        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <Input
            placeholder="Search drink..."
            style={{ width: 250 }}
            onChange={(e) => setSearch(e.target.value)}
          />

          <Select
            allowClear
            placeholder="Filter Type"
            style={{ width: 150 }}
            onChange={(v) => setTypeFilter(v)}
          >
            <Select.Option value="Box">Box</Select.Option>
            <Select.Option value="Bottle">Bottle</Select.Option>
          </Select>

          <Select
            allowClear
            placeholder="Sort Stock"
            style={{ width: 150 }}
            onChange={(v) => setStockSort(v)}
          >
            <Select.Option value="high">High Stock</Select.Option>
            <Select.Option value="low">Low Stock</Select.Option>
          </Select>

          <RangePicker
            style={{ width: 280 }}
            value={dateRange}
            onChange={(values) => setDateRange(values || [])}
            allowClear
          />
        </div>
      </div>

      <div className="page-card table-card">
        <div className="table-card-header">
          <div>
            <h3>Inventory List</h3>
            <p>View and manage all available drinks and stock entries.</p>
          </div>
        </div>

        <Table
        dataSource={filteredData}
        columns={columns}
        rowKey="id"
         onRow={(record) => {
          const logs = stockLogsMap[Number(record.id)] || [];
          const summary = getStockSummary(logs);

          const isLowStock = summary.totalBottle <= 10;

          return {
            style: {
              backgroundColor: isLowStock ? "#fff1f0" : undefined,
            },

            onMouseEnter: (e) => {
              if (isLowStock) {
                e.currentTarget.querySelectorAll("td").forEach((td) => {
                  td.style.backgroundColor = "#fff1f0";
                });
              }
            },

            onMouseLeave: (e) => {
              if (isLowStock) {
                e.currentTarget.querySelectorAll("td").forEach((td) => {
                  td.style.backgroundColor = "#fff1f0";
                });
              }
            },
          };
        }}
        
        expandable={{
        expandedRowRender: (record) => {
          const logs = stockLogsMap[Number(record.id)] || [];
          const { totalPaid, totalBox, totalBottle, totalVolumeLTR } =
            getStockSummary(logs);

    return (
      <div style={{ padding: 10 }}>
        <h4>Stock Summary</h4>

        {/* ================= SUMMARY BOX ================= */}
        <div style={{ display: "flex", gap: 10, marginBottom: 15 }}>
          
          <div style={boxStyle}>
            <div>Total Box</div>
            <h2>{totalBox}</h2>
          </div>

          <div style={boxStyle}>
            <div>Total Bottle</div>
            <h2>{totalBottle}</h2>
          </div>

          <div style={boxStyle}>
            <div>Total Volume (L)</div>
            <h2>{totalVolumeLTR.toFixed(2)}</h2>
          </div>

          <div style={boxStyle}>
          <div>Total Paid</div>
          <h2>{totalPaid}</h2>
        </div>

        </div>

        {/* ================= STOCK LOG TABLE ================= */}
        <Table
          dataSource={logs}
          rowKey="id"
          pagination={false}
          size="small"
          columns={[
            { title: "S.No", render: (_, __, i) => i + 1 },
            { title: "Scan Bottle Code", dataIndex: "scan_bottle_code" },
            { title: "Scan Box Code", dataIndex: "scan_box_code" },
            { title: "Type", dataIndex: "type" },
            { title: "Supplier", dataIndex: "supplier" },
            { title: "Units/Box", dataIndex: "units_per_box" },
            { title: "Bottle ML", dataIndex: "bottle_volume" },
            { title: "Price/Box", dataIndex: "price_box" },
            { title: "Price/Bottle", dataIndex: "price_per_bottle" },
            { title: "Box Qty", dataIndex: "box_qty" },
            { title: "Bottle Qty", dataIndex: "bottle_qty" },
            {
                title: "Paid Amount",
                dataIndex: "paid_amount",
              },
            {
              title: "Added Stock",
              render: (_, r) => r.in_stock
            },
            {
              title: "Date",
              dataIndex: "added_on",
              render: (text) =>
                text ? new Date(text).toLocaleString() : "-"
            },

            //  ADD THIS ACTION COLUMN HERE
          {
            title: "Action",
            render: (_, log) => (
              <div style={{ display: "flex", gap: 6 }}>

                <Button
                  type="link"
                  style={{ color:"#1677ff", padding:0}}
                  disabled={!canUpdateModule(MODULE_KEY)}
                  onClick={() => handleEditStock(log)}
                >
                  Edit
                </Button>

                <Button
                  type="link"
                  danger
                  style={{padding:0}}
                  disabled={!canDeleteModule(MODULE_KEY)}
                  onClick={() =>
                    handleDeleteStock(log.id, record.id)
                  }
                >
                  Delete
                </Button>

              </div>
            ),
          },
          ]}
        />
      </div>
    );
  },

  rowExpandable: () => true,

  onExpand: (expanded, record) => {
    if (expanded) {
      loadStockLogs(record.id);
    }
  },
}}
/>
</div>

      {/* ================= ADD STOCK MODAL ================= */}
      <Modal
          title="Update Stock"
          open={stockOpen}
          onCancel={() => setStockOpen(false)}     
          okText="Save Stock"
          onOk={async () => {
            try {
              const values = await stockForm.validateFields();
              console.log(" FINAL VALUES:", values);

              await handleAddStock(values);
            } catch (err) {
              console.log("VALIDATION ERROR:", err);
            }
          }}
        >
       <Form form={stockForm} layout="vertical">
         <Row gutter={12}>
  {/* Row 1: Drink and Supplier */}
  <Col span={12}>
    <Form.Item
      name="drink_id"
      label="Drink"
      rules={[{ required: true, message: "Please enter Drink name" }]}
    >
      <Select
        showSearch
        onChange={(value) => {
          const matched = data.find(d => Number(d.id) === Number(value));
          setStockDrinkFields(matched);
        }}
      >
        {data.map((d) => (
          <Select.Option key={d.id} value={d.id}>
            {d.name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  </Col>

  <Col span={12}>
    <Form.Item name="supplier" label="Supplier" rules={[{ required: true }]}>
      <Select showSearch>
        {suppliers.map((s) => (
          <Select.Option key={s.id} value={s.name}>
            {s.name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  </Col>

  {/* Row 2: Scan Bottle Code and Scan Box Code */}
  <Col span={12}>
    <Form.Item name="scan_bottle_code" label="Scan Bottle Code">
      <Input placeholder="Bottle barcode" />
    </Form.Item>
  </Col>

  <Col span={12}>
    <Form.Item name="scan_box_code" label="Scan Box Code">
      <Input placeholder="Box barcode" />
    </Form.Item>
  </Col>

  {/* Row 3: Type and Bottle Volume */}
  <Col span={12}>
    <Form.Item name="type" label="Type">
      <Select>
        <Select.Option value="Box">Box</Select.Option>
        <Select.Option value="Bottle">Bottle</Select.Option>
      </Select>
    </Form.Item>
  </Col>

  <Col span={12}>
    <Form.Item name="bottle_volume" label="Bottle Volume">
      <InputNumber style={{ width: "100%" }} placeholder="Enter volume in ml" />
    </Form.Item>
  </Col>

  {/* Row 4: Price Per Bottle and Box Fields Row 1 */}
  <Col span={12}>
    <Form.Item name="price_per_bottle" label="Price / Bottle">
      <InputNumber style={{ width: "100%" }} placeholder="Price per bottle" />
    </Form.Item>
  </Col>

  <Col span={12}>
    <div style={{ display: type === "Box" ? "block" : "none" }}>
      <Form.Item name="units_per_box" label="Units / Box">
        <InputNumber style={{ width: "100%" }} placeholder="Units per box" />
      </Form.Item>
    </div>
    <div style={{ display: type === "Bottle" ? "block" : "none" }}>
      <Form.Item name="bottle_qty" label="Bottle Qty">
        <InputNumber style={{ width: "100%" }} placeholder="Number of bottles" />
      </Form.Item>
    </div>
  </Col>

  {/* Row 5: Box Fields Row 2 and Row 3 */}
  <Col span={12}>
    <div style={{ display: type === "Box" ? "block" : "none" }}>
      <Form.Item name="price_box" label="Price / Box">
        <InputNumber style={{ width: "100%" }} placeholder="Price per box" />
      </Form.Item>
    </div>
    <div style={{ display: type === "Bottle" ? "none" : "none" }}>
      {/* Empty for bottle type */}
    </div>
  </Col>

  <Col span={12}>
    <div style={{ display: type === "Box" ? "block" : "none" }}>
      <Form.Item name="box_qty" label="Box Qty">
        <InputNumber style={{ width: "100%" }} placeholder="Number of boxes" />
      </Form.Item>
    </div>
  </Col>

  {/* Row 6: Added Stock and Paid Amount */}
  <Col span={12}>
    <Form.Item name="in_stock" label="Added Stock">
      <InputNumber style={{ width: "100%" }} />
    </Form.Item>
  </Col>

  <Col span={12}>
    <Form.Item name="paid_amount" label="Paid Amount">
      <InputNumber style={{ width: "100%" }} />
    </Form.Item>
  </Col>
</Row>
      </Form>
      </Modal>

      <Drawer
      open={newStockOpen}
      onClose={handleCloseNewStock}
      title="New Stock Entry"
      width={720}
      extra={
        <div style={{ display: "flex", gap: 8 }}>
          <Button onClick={handleCloseNewStock}>Cancel</Button>

          <Button type="primary" 
               onClick={() => newStockForm.submit()}>
            Save
          </Button>
        </div>
      }
    >
      <Form
        form={newStockForm}
        layout="vertical"
        onFinish={handleCreateNewStock}
        >
      <div className="page-card table-card">
        <div className="table-card-header">
          <div>
            <h3>Create New Stock Details</h3>
            <p>Fill the details below to save the stock entry.</p>
          </div>
        </div>

      <Row gutter={12}>
            <Form.Item name="drink_id" hidden>
              <Input />
            </Form.Item>

       {/* SCAN BOTTLE CODE */}
<Col span={12}>
  <Form.Item
    name="scan_bottle_code"
    label="Scan Bottle Code"
    tooltip="Read only. Use scanner button to fill code"
  >
    <Input
      placeholder="Use scanner to fill bottle code"
      readOnly
      style={{
        backgroundColor: "#f5f5f5",
        cursor: "not-allowed",
      }}
      onClick={() =>
        notify.info("Read Only", "Use scanner icon to scan bottle code")
      }
      addonAfter={
        <div
          onClick={() => openScanner("scan_bottle_code")}
          style={{
            background: "#1677ff",
            color: "#fff",
            padding: "6px 10px",
            borderRadius: "6px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ScanOutlined />
        </div>
      }
    />
  </Form.Item>
</Col>

{/* SCAN BOX CODE */}
<Col span={12}>
  <Form.Item
    name="scan_box_code"
    label="Scan Box Code"
    tooltip="Read only. Use scanner button to fill code"
  >
    <Input
      placeholder="Use scanner to fill box code"
      readOnly
      style={{
        backgroundColor: "#f5f5f5",
        cursor: "not-allowed",
      }}
      onClick={() =>
        notify.info("Read Only", "Use scanner icon to scan box code")
      }
      addonAfter={
        <div
          onClick={() => openScanner("scan_box_code")}
          style={{
            background: "#1677ff",
            color: "#fff",
            padding: "6px 10px",
            borderRadius: "6px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ScanOutlined />
        </div>
      }
    />
  </Form.Item>
</Col>

        <Col span={12}>
          <Form.Item
            name="name"
            label="Drink Name"
            rules={[{ required: true, message: "Enter drink name" }]}
          >
              <AutoComplete
                options={drinkOptions}
                placeholder="Type or select drink name..."
                filterOption={(inputValue, option) =>
                  option?.value?.toLowerCase().includes(inputValue.toLowerCase())
                }
                onSelect={(value) => {
                  const matched = data.find(
                    (drink) => drink?.name.toLowerCase() === value.toLowerCase()
                  );

                  setNewStockDrinkFields(matched);
                }}
                onChange={(value) => {
                  const matched = data.find(
                    (drink) => drink?.name.toLowerCase() === value.toLowerCase()
                  );

                  setNewStockDrinkFields(matched);
                  newStockForm.setFieldValue("name", value);
                }}
              />
          </Form.Item>

        </Col>

        <Col span={12}>
        <Form.Item name="supplier" label="Supplier">
            <Select>
              {suppliers.map(s => (
                <Select.Option key={s.id} value={s.name}>
                  {s.name}
                </Select.Option>
              ))}
            </Select>
        </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item name="category_name" label="Category">
            <Input />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item name="margin_price" label="Original Price"
        
          >
          <InputNumber  style={{ width: "100%" }} />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item name="sell_price" label="Sell Price"
          
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item name="type" label="Type">
            <Select>
              <Select.Option value="Box">Box</Select.Option>
              <Select.Option value="Bottle">Bottle</Select.Option>
            </Select>
          </Form.Item>
        </Col>


          {newType === "Box" && (
            <>
            <Col span={12}>
              <Form.Item name="units_per_box" label="Units/Box"
            
              >
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
            </Col>

            

            <Col span={12}>
              <Form.Item name="price_box" label="Box Price"
            
              >
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="box_qty" label="Box Qty"
              
              >
                <InputNumber  style={{ width: "100%" }} />
              </Form.Item>
            </Col>

          </>
          )}

      <Col span={12}>
        <Form.Item name="bottle_volume" label="Bottle Volume"
        
        >
          <InputNumber  style={{ width: "100%" }} />
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item name="price_per_bottle" label="Bottle Price" 
        
        >
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>
      </Col>

    {newType === "Bottle" && (
      <Col span={12}>
        <Form.Item name="bottle_qty" label="Bottle Qty" >
          <InputNumber  style={{ width: "100%" }} />
        </Form.Item>
      </Col>

    )}
      {newType !== "Bottle" && (
      <Col span={12}>
        <Form.Item name="in_stock" label="Added Stock" >
          <InputNumber  
          style={{ width: "100%" }} 
            disabled={newType === "Bottle"}
          />
        </Form.Item>
      </Col>
      )}

        <Col span={12}>
          <Form.Item name="paid_amount" label="Paid Amount" >
              <InputNumber style={{ width: "100%" }} />
        </Form.Item>
        </Col>

        </Row>
       </div>
      </Form>
    </Drawer>






{/*========scanner=========*/}

<Modal
  open={scanModalOpen}
  footer={null}
  onCancel={() => setScanModalOpen(false)}
  title={null}
  closable={false}
  centered
  width={340}
  styles={{
    content: {
      background: "transparent",
      boxShadow: "none",
      padding: 0,
    },
  }}
>
  <div>
    <div className="scanner-frame">

      <div id="reader" />

      <div className="scanner-placeholder" />

      {scanModalOpen && <div className="scan-line" />}

      {/* INPUT INSIDE POPUP */}
      <div className="scan-input-box">

        {/* ONLY BOTTLE INPUT */}
        {scanField === "scan_bottle_code" && (
          <input
            ref={inputRef}
            autoFocus
            placeholder="Bottle Code"
            value={bottleCode || ""}
            onChange={(e) => {
              newStockForm.setFieldsValue({
                scan_bottle_code: e.target.value,
              });
            }}
          />
        )}

        {/* ONLY BOX INPUT */}
        {scanField === "scan_box_code" && (
          <input
            ref={inputRef}
            autoFocus
            placeholder="Box Code"
            value={boxCode || ""}
            onChange={(e) => {
              newStockForm.setFieldsValue({
                scan_box_code: e.target.value,
              });
            }}
          />
        )}

      </div>

    </div>
  </div>
</Modal>




      {/* ================= ADD DRINK DRAWER ================= */}
      <Drawer
        open={drinkOpen}
        onClose={closeDrinkModal}
        onSubmit={handleCreateDrink}
       title={editingDrinkId ? "Update Drink" : "Add Drinks"}
        form={drinkForm}
        extra={
        <div style={{ display: "flex", gap: 8 }}>
          <Button onClick={closeDrinkModal}>Cancel</Button>

          <Button
            type="primary"
            onClick={() => drinkForm.submit()}
          >
            Save
          </Button>
        </div>
  }
      >
        <div className="page-card table-card">
          <div className="table-card-header">
            <div>
              <h3>Create Drinks Details</h3>
              <p>Fill the details below to save the drink.</p>
            </div>
          </div>

          <Form form={drinkForm} layout="vertical" onFinish={handleCreateDrink}>
  
      <Form.Item name="name" label="Drink Name">
        <Input style={{ width: "100%" }} />
      </Form.Item>

      <Form.Item
        name="qty"
        label="Volume"
        rules={[
          { required: true, message: "Enter Volume" },
          {
            validator: (_, value) => {
              if (value < 0) return Promise.reject("Cannot be negative");
              return Promise.resolve();
            },
          },
        ]}
      >
        <Input type="number" style={{ width: "100%" }} />
      </Form.Item>

        <Form.Item name="unit" label="Unit">
          <Select style={{ width: "100%" }}>
            <Select.Option value="ml">ml</Select.Option>
            <Select.Option value="l">Liter</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item name="sell_price" label="Sell Price">
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item name="margin_price" label="Original Price">
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>

      </Form>
        </div>
      </Drawer>
    </div>
  );
}

export default Inventory;
